import { render, staticRenderFns } from "./ProjectUserDeleter.vue?vue&type=template&id=6aa5a36e&scoped=true"
import script from "./ProjectUserDeleter.vue?vue&type=script&lang=ts"
export * from "./ProjectUserDeleter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa5a36e",
  null
  
)

export default component.exports